/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';

import { isBrowserClient } from '../utils/device-utils';

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 * See https://github.com/react-component/select/blob/423f860b8582e8d105ce67d189da096db36c0ba6/src/hooks/useLayoutEffect.ts
 */
export default function useLayoutEffect(effect: React.EffectCallback, deps?: React.DependencyList) {
  // Never happen in test env
  if (isBrowserClient) {
    /* istanbul ignore next */
    React.useLayoutEffect(effect, deps);
  } else {
    React.useEffect(effect, deps);
  }
}
/* eslint-enable */
